import { render, staticRenderFns } from "./studentWorks.vue?vue&type=template&id=d9c3d1ec&scoped=true"
import script from "./studentWorks.vue?vue&type=script&lang=js"
export * from "./studentWorks.vue?vue&type=script&lang=js"
import style0 from "./studentWorks.vue?vue&type=style&index=0&id=d9c3d1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c3d1ec",
  null
  
)

export default component.exports